import { useMutation } from '@tanstack/react-query';

import { Envelope, EnvelopeDraft } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getSignatureDraft } from '../../requests/getSignatureDraft';

type GetSignatureDraftVariables = {
  envelope: Envelope;
  draftId: string;
};

export const useGetSignatureDraft = () => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    EnvelopeDraft | undefined,
    Error,
    GetSignatureDraftVariables
  >({
    mutationFn: ({ envelope, draftId }) =>
      getSignatureDraft(constructGet, envelope, draftId).then(
        (response) => response?.data,
      ),
  });

  return { getSignatureDraft: mutateAsync, ...rest };
};
